// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"49093e62","455":"354299c3","977":"68c2ae11"}[chunkId] + ".chunk.js";
};